/** Tutorial disabled flag constant */
export const tutorialDisabled = false;

/** URL for Prep Instructions */
export const prepInstructions = 'https://ehe.health/pre-exam-guide';

/** Password Allowed special characters */
export const passwordAllowedSpecialChars = /[$^*.(){}?!@#%&",~`'_<>;:|\-\\/[\]]/.source;

/** Password Allowed special characters */
export const passwordSpecialCharsValidatorRegExp = new RegExp(
	'^(?=.*?' + passwordAllowedSpecialChars + ')' + passwordAllowedSpecialChars['splice'](1, 0, 'A-z0-9') + '+$'
);

/** Responsive breakpoints (matches SCSS media queries) */
export const MOBILE_BREAKPOINT = 768; // max-width for mobile (<768px)
export const DESKTOP_BREAKPOINT = 992; // min-width for desktop
